import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import classNames from 'classnames';

import CustomScrollbars from '../CustomScrollbars';

const Item = ({children, isHighlighted, ...rest}) => (
  <div
    className={classNames('dropdown__item', {'dropdown__item--highlighted': isHighlighted})}
    {...rest}
  >
    {children}
  </div>
);

class Menu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      size: -1
    };

    this.handleRef = this.handleRef.bind(this);
  }

  handleRef(ref) {
    if (ref) {
      this.self = ref;
    }
  }

  updateSize() {
    if (this.state.size !== this.self.clientHeight) {
      this.setState({size: this.self.clientHeight});
      this.props.onSizeChange(this.self.clientHeight);
    }
  }

  componentDidMount() {
    this.updateSize();
  }

  componentDidUpdate() {
    this.updateSize();
  }

  render() {
    const {options, getItemProps, highlightedIndex} = this.props;

    return (
      <div ref={this.handleRef}>
        {options.map((option, index) => (
          <Item
            key={`${option}${index}`}
            {...getItemProps({
              index,
              item: option,
              isHighlighted: highlightedIndex === index
            })}
          >
            {option}
          </Item>
        ))}
      </div>
    );
  }
}

Item.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  isHighlighted: PropTypes.bool.isRequired
};

class Dropdown extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      size: -1
    };

    this.prevInputValue = '';

    this.handleMenuSizeChange = this.handleMenuSizeChange.bind(this);
    this.handleDownshiftStateChange = this.handleDownshiftStateChange.bind(this);
    this.handleDownshiftInputValueChange = this.handleDownshiftInputValueChange.bind(this);
  }

  handleMenuSizeChange(size) {
    let height = size;

    if (Math.floor(height / 200) > 0) {
      height = 200;
    }

    this.setState({size: height});
  }

  handleDownshiftStateChange({inputValue}) {
    if (inputValue && this.prevInputValue !== inputValue) {
      this.props.onChange(inputValue);
    }
    this.prevInputValue = inputValue;
    this.props.input.onChange(inputValue);
  }

  handleDownshiftInputValueChange(val, {inputValue, selectedItem, selectItem}) {
    const ind = this.props.options.indexOf(val);
    if (ind !== -1 && inputValue !== selectedItem) {
      selectItem(val);
    }
  }

  render() {
    const {children, options, input} = this.props;

    return (
      <Downshift
        {...input}
        initialSelectedItem={'' || input.value}
        getItemId={index => `${input.name}-${index}`}
        onInputValueChange={this.handleDownshiftInputValueChange}
        onStateChange={this.handleDownshiftStateChange}
      >
        {({
          isOpen,
          highlightedIndex,
          getMenuProps,
          getInputProps,
          getItemProps,
          openMenu,
          selectedItem,
          selectItem,
          closeMenu
        }) => (
          <div className="form-group">
            {React.cloneElement(children, {
              ...getInputProps({
                onKeyDown: e => {
                  if (['Delete', 'Backspace'].includes(e.key)) {
                    if (!isOpen) {
                      openMenu();
                    }
                  } else if (e.key === 'Tab') {
                    selectItem(selectedItem);
                    closeMenu();
                  }
                },
                input: {
                  ...input,
                  onFocus: e => {
                    openMenu();
                    input.onFocus(e);
                  }
                }
              })
            })}

            {isOpen &&
              options.length > 0 && (
                <div className="dropdown" {...getMenuProps()}>
                  <CustomScrollbars style={{height: this.state.size}}>
                    <Menu
                      onSizeChange={this.handleMenuSizeChange}
                      getItemProps={getItemProps}
                      highlightedIndex={highlightedIndex}
                      options={options}
                    />
                  </CustomScrollbars>
                </div>
              )}
          </div>
        )}
      </Downshift>
    );
  }
}

Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func
};

export default Dropdown;



// WEBPACK FOOTER //
// ./components/Form/Dropdown.jsx